import { Icon } from '@acme/assets';
import { formatDateTime } from '@acme/foundation';

export type DocumentType = {
  id?: string;
  name?: string | null;
  documentTypeName?: string | null;
  uploadDate?: string;
};

interface DocumentsProps {
  documents: DocumentType[];
  onDownload: (d: DocumentType) => void | Promise<void>;
  downloadingId?: string | null;
}

const COLUMNS = 3;

export const Documents = ({
  documents,
  onDownload,
  downloadingId = null,
}: DocumentsProps) => {
  const columns = Array.from({ length: COLUMNS }, (_, colIdx) =>
    documents.filter((_, i) => i % COLUMNS === colIdx)
  );

  return (
    <div className="overflow-auto">
      <div className="grid grid-cols-3 gap-4">
        {columns.map((colDocs, colIdx) => (
          <div
            key={colIdx}
            className={
              colIdx < COLUMNS - 1 ? 'border-r border-gray-200 pr-4' : ''
            }
          >
            {colDocs.map((d, idx) => (
              <div
                className="flex items-center gap-3 py-2"
                key={d.id ?? `${colIdx}-${idx}`}
              >
                <Icon
                  name="file-image"
                  size={24}
                  className="text-gray-400 shrink-0"
                />
                <div className="min-w-0 flex-1">
                  <div className="text-gray-900 text-sm font-medium truncate">
                    {d.name}
                  </div>
                  {d.documentTypeName && (
                    <div className="text-gray-600 text-xs truncate">
                      {d.documentTypeName}
                    </div>
                  )}
                  <div className="flex gap-2 text-gray-500 text-xs">
                    <span>Загружено:</span>
                    <span className="truncate">
                      {formatDateTime(d.uploadDate)}
                    </span>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => onDownload(d)}
                  disabled={downloadingId === d.id}
                  className="p-1 text-brand-purple-900 hover:bg-gray-100 rounded disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent"
                  title="Скачать"
                >
                  {downloadingId === d.id ? (
                    <span className="inline-block w-4 h-4 border-2 border-brand-purple-900 border-t-transparent rounded-full animate-spin" />
                  ) : (
                    <Icon name="download-outline" size={16} />
                  )}
                </button>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
